import React from 'react';

export function useOperation (action: () => Promise<void>, deps: React.DependencyList) {

  const [isProcessing, setIsProcessing] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState<any>();

  React.useEffect(() => {
    setIsProcessing(false);
    setErrorMessage(undefined);
  }, [...deps]);

  const onAction = React.useCallback(async () => {
    try {
      setIsProcessing(true);
      setErrorMessage(undefined);
      await action();
    } catch (err) {
      setErrorMessage(err);
    } finally {
      setIsProcessing(false);
    }
  }, [...deps]);

  return [onAction, errorMessage, isProcessing]
}
